import React, { useEffect, useState } from "react";
import WeekHoursSetup from "./Components/WeekHoursSetup/WeekHoursSetup";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_API_URL } from "../../../utils/consts";
import SettingsHeader from "../Components/SettingsHeader/SettingsHeader";
import { useTranslation } from "react-i18next";

const WorkingPatternDetails = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [workingPatternDetails, setWorkingPatternDetails] =
    useState<any>(undefined);
  useEffect(() => {
    if (params.id !== "new") {
      axios
        .get(`${BASE_API_URL}/working-patterns/${params.id}`)
        .then((res) => {
          setWorkingPatternDetails(res.data);
        })
        .catch((error) => console.error(error));
    }
  }, [params.id]);
  return (
    <>
      <SettingsHeader
        title={
          !workingPatternDetails
            ? t("New contract type")
            : t("Edit contract type")
        }
        onBack={() => navigate(-1)}
      />
      <div className="settingsForm">
        <WeekHoursSetup
          workingPatternDetails={workingPatternDetails?.workingPattern}
        />
      </div>
    </>
  );
};

export default WorkingPatternDetails;
